import {snakeCase} from 'lodash'
import {Context} from '@/project'
import {Transformer} from '@/lib/axiosAddTransforms'
import objectTransformer from '@/lib/objectTransformer'

const dataKey: Transformer<Context> = (payload) => {
  if(payload.data) {
    payload.data = objectTransformer(payload.data, snakeCase, true)
  }
  if(payload.params) {
    payload.params = objectTransformer(payload.params, snakeCase, true)
  }
  return payload
}

export default dataKey
